import { LocationQuery } from 'vue-router';
import { PerformancesActionLogService } from './performances-action-log.service';
const service = new PerformancesActionLogService();

interface PerformancesActionLogState {}

const state: PerformancesActionLogState = {};

const getters = {};

const mutations = {};

const actions = {
   async getPerformancesActionLog(context: any, payload: { contractId: number; query: LocationQuery }) {
      return service.getPerformancesActionLog(payload.contractId, payload.query);
   },
};

export default {
   namespaced: true,
   state,
   getters,
   mutations,
   actions,
};
